/* eslint-disable max-len */
import { Text, Uploading } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ONE_MB_IN_BYTES } from '../services/speedTest.service';
import { timeLeftInMinutesFormatter } from '../utils/formatters.utils';
import { ClockIcon } from './icons/ClockIcon';
import { Progress } from './ui/Progress';

interface IProps {
  // progress:number;
  isConnected: boolean;
  totalFileSize: number
  totalUploadedFilesSize: { [questionNumber: string] : number };
  totalUploadSpeed:{ [questionNumber: string] : number };
}

export const Upload:React.FC<IProps> = ({
  isConnected, totalFileSize, totalUploadedFilesSize, totalUploadSpeed,
}) => {
  const { t } = useTranslation();
  const totalUploaded = Object.values(totalUploadedFilesSize).reduce((acc, size) => acc + size, 0);
  const totalSpeed = Object.values(totalUploadSpeed).reduce((acc, speed) => acc + speed, 0);
  const progress = Math.round((totalUploaded / totalFileSize) * 100);
  const timeLeft = totalSpeed ? ((totalFileSize - totalUploaded) / ONE_MB_IN_BYTES) / totalSpeed : 0;

  return (
    <div className="myinterview-widget-upload">
      <div className="myinterview-widget-upload__icon">
        <Uploading />
      </div>
      <Text className="myinterview-widget-upload__title" size="H2-Bold">{t('upload.title')}</Text>
      <Text className="myinterview-widget-upload__sub-title" size="S-Regular" color="neutral-50">{t('upload.subtitle')}</Text>
      {isConnected
        ? (
          <>
            <div className="myinterview-widget-upload__progress">
              <Progress progress={progress} />
            </div>
            <div className="myinterview-widget-upload__time-left">
              <ClockIcon />
              <Text>{timeLeftInMinutesFormatter(timeLeft)}</Text>
            </div>
            {/* <Text>{`${timeLeft.toFixed(2)} seconds left`}</Text> */}
            {/* <Text>{`${totalSpeed.toFixed(2)} MBps`}</Text> */}
          </>
        ) : <Text>{t('upload.errorInfo')}</Text>}
    </div>
  );
};
